import { combineReducers } from 'redux';
import bulkExportReducer from './bulkExportReducer';
import customBulkExportReducer from './customBulkExportReducer';
import contractsGridReducer from './contractsGridReducer';
import priceExplorerGridReducer from './PriceExplorerGridReducer';
import pricingGridComponentReducer from './PricingGridComponentReducer';
import pricingGridLayoutReducer from './PricingGridLayoutReducer';
var rootReducer = combineReducers({
  bulkExport: bulkExportReducer,
  customBulkExport: customBulkExportReducer,
  contractsGrid: contractsGridReducer,
  priceExplorerGrid: priceExplorerGridReducer,
  pricingGrid: pricingGridComponentReducer,
  pricingGridLayout: pricingGridLayoutReducer
});
export default rootReducer;